import { ResponsiveBreakpoint } from "./responsive-breakpoint.model";

export interface GaugeSettings {
    size?: number;
    label?: string;
    breakpoints?: ResponsiveBreakpoint[];
}
